import { API_URL } from "../service.config";

export default {
  signIn(user: any) {
    return API_URL.post(`/auth/sign-in`, user);
  },
  sendEmailToChangePassword(email: any) {
    return API_URL.post(`/auth/change-password`, email);
  },
  changePassword(info: any) {
    return API_URL.patch(
      `/auth/reset-password`,
      { password: info.password },
      {
        headers: {
          Authorization: `Bearer ${info.token}`
        }
      }
    );
  }
};
